module.exports = __webpack_public_path__ + "static/media/1.8f1b721f.jpg";